module.exports = __webpack_public_path__ + "images/e6d6fdce17c6e50728c337d14aabdef4.svg";